<template functional>
  <div class="d-flex fd-column">
    <span class="h6 text-bold ellipsize" selenium="current-job-customer">{{ props.fullName }}</span>
    <span class="text-lg c-gray70 ellipsize" selenium="current-job-subtask">
      {{ props.serviceName }}
    </span>
    <span
        class="text-lg c-gray70 x-white-space-pre-wrap"
        selenium="current-job-location">{{ props.location }}</span>
  </div>
</template>

<script>
export default {
  name: 'job-list-item-details',
  props: {
    fullName: String,
    serviceName: String,
    location: String,
  },
};
</script>
